$(document).ready(function () {
  $(window).on('resize scroll', function() {
    if ($(window).width() < 578 && $(window).scrollTop() > 100) {
      $('#cookie-banner').addClass('move-up');
      $('#mobile-track-btn').addClass('d-block');
    } else {
      $('#cookie-banner').removeClass('move-up');
      $('#mobile-track-btn').removeClass('d-block');
    }
  });
});
